import { createReducer } from '@src/redux/helpers/createReducer';
import { GET_FETCHUSER, SAVE_USER_INFO } from './constants';

const initialState = {
  uuid: '',
  optumId: '',
  firstName: '',
  lastName: '',
  getUserSaga: { isLoading: false, isError: false, isSuccess: false },
};

export const userInfoReducer = createReducer(initialState, {
  [`${SAVE_USER_INFO}`]: (state, action) => {
    return { ...action.payload };
  },
  [`${GET_FETCHUSER}_STARTED`]: (state, action) => {
    return {
      ...state,
      getUserSaga: { isLoading: true, isError: false, isSuccess: false },
    };
  },
  [`${GET_FETCHUSER}_SUCCESS`]: (state, action) => {
    return {
      ...state,
      getUserSaga: { isLoading: false, isError: false, isSuccess: true },
    };
  },
  [`${GET_FETCHUSER}_ERROR`]: (state, action) => {
    return {
      ...state,
      getUserSaga: { isLoading: false, isError: true, isSuccess: false },
    };
  },
});
